import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import CarouselList from '../../components/CarouselList/CarouselList.js'
import focusable from '../../components/Focusable/Focusable'
import {
  truncate,
  generateErrorData,
  ComcastErrorType,
} from '../../../../shared/helpers.js'
import ErrorModal from '../../components/ErrorModal/ErrorModal'
import Spinner from '../../components/Spinner/Spinner'
import * as UI from '../../lib/ui'
import { getShowDetails } from '../../actions/contentActions'
import tts from '../../lib/TTS'
import { store } from '../../store.js'
import { deeplinked } from '../../components/Deeplink'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import Platform from '../../platforms'
import ContinueWatching from '../../components/ContinueWatching/ContinueWatching.jsx'
import {
  PLAY_BUTTON_TYPE,
  MY_LIST_BUTTON_TYPE,
} from '../../components/ContinueWatching/ActionButtons'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

class ShowDetailsScreen extends React.Component {
  constructor(props) {
    super(props)

    this.lastSlug = this.props.router.params.slug

    this.carouselCoordinates = {}

    this.carouselCoordinates = null

    this.descriptionText = null
    this.descriptionModal = null

    this.state = {
      id: 'ShowDetailScreen',
      errorVisible: false,
      descriptionModalVisible: false,
      collections: [],
      heroCollection: [],
      spinnerVisible: true,
      buttonFocus: false,
      headerHeight: null,
    }
    UI.setLoadingState(true)

    this.continueWatchingRef = React.createRef()
    this.carouselList = React.createRef()
    this.headerHeightRef = React.createRef()
  }

  componentDidUpdate(prevProps) {
    if (this.lastSlug !== this.props.router.params.slug) {
      this.lastSlug = this.props.router.params.slug
      this.setState({
        errorVisible: false,
        collections: [],
        heroCollection: [],
        descriptionModalVisible: false,
        spinnerVisible: true,
      })
      UI.setLoadingState(true)
      this.buildScreen()
      this.button?.setFocus()
    }

    if (
      this.props.router.location.pathname !== prevProps.router.location.pathname
    ) {
      this.setState({ headerHeight: 0 })
    }

    const { collections, pageDetails, continueWatchingData } =
      this.props.showDetail
    const { collections: prevCollections, pageDetails: prevPageDetails } =
      prevProps.showDetail

    const collectionLengthChanged =
      collections.length !== prevCollections.length
    const pageDetailsCidChanged = pageDetails.cid !== prevPageDetails.cid

    if (collectionLengthChanged || pageDetailsCidChanged) {
      let continueWatching = null

      if (Object.keys(continueWatchingData).length > 0) {
        continueWatching = continueWatchingData
      }

      this.setState({
        focusedComponent: 'HeroCarousel',
        collections,
        pageDetails,
        spinnerVisible: false,
      })
      this.setState({ continueWatching })
      googleAnalytics4.sendPageViewEvent(
        `Show Detail | ${this.props.showDetail.pageDetails}`
      )
    }
  }

  componentWillUnmount() {
    tts.stopRead()
    store.dispatch({
      type: 'RESET_SHOW_DETAILS_DATA',
    })
  }

  /**
   * Sets A Virtual Dom reference to the errorModal
   *
   * @param { Object} component
   * @param { String } name
   */
  setErrorModalRef(component, name) {
    if (null !== component) {
      this[name] = component
      if (name === 'errorModal' && this.state.errorVisible) {
        this[name]?.setFocus()
      }
    }
  }

  /**
   * Allows user to dismiss the error modal
   */
  toggleErrorModal = () => {
    this.setState((state) => ({
      errorVisible: !state.errorVisible,
      buttonFocus: true,
    }))

    if (!this.state.errorVisible) {
      this.button?.setFocus()
    }
  }

  toggleErrorModalBound = this.toggleErrorModal.bind(this)

  componentDidMount() {
    Platform.reportAppReady()
    this.buildScreen()
    UI.registerFocusableComponent({ screen: this.state.id })

    UI.setFocusedComponent('ShowsScreen')
  }

  buildScreen() {
    try {
      getShowDetails(this.props.router.params.slug, this.props.userId)
    } catch (error) {
      UI.setLoadingState(false)

      const errorObj = generateErrorData(error)

      store.dispatch({
        type: 'TRIGGER_ERROR',
        payload: {
          error: {
            ...errorObj,
            content: {
              errorPath: this.props.router.location.pathname,
            },
            codeBaseLocation: 'ShowDetailsScreen - getShowInfo',
            errorType: ComcastErrorType.network,
          },
        },
      })
      this.props.router.navigate('/error', { replace: true })
    }
    UI.setSidePanelVisibility(false)
  }

  onKeyEvent(key) {
    let handled = false
    const focusedComponent = window.focusedComponent

    if ('DOWN' === key) {
      this.setState({
        headerHeight: this.headerHeightRef?.current?.clientHeight,
      })
    }

    if (focusedComponent.componentType) {
      tts.stopRead()
      if (
        [PLAY_BUTTON_TYPE, MY_LIST_BUTTON_TYPE].includes(
          focusedComponent.componentType
        )
      ) {
        if ('DOWN' === key) {
          if (this.state.collections.length !== 0) {
            this.carouselList?.instance?.carousels[0]?.setFocus()

            if (null !== this.carouselList) {
              this.carouselCoordinates =
                this.carouselList?.instance?.carouselOuterList?.current?.getBoundingClientRect()
            }
            handled = false

            this.setState({
              carouselFocused: true,
              buttonFocus: false,
              focusedComponent: 'CarouselList',
            })
          }
        }
      }

      if ('descriptionText' === focusedComponent.componentType) {
        if ('DOWN' === key) {
          if (this.state.collections.length !== 0) {
            this.carouselList?.instance?.carousels[0]?.setFocus()
            if (null !== this.carouselList) {
              this.carouselCoordinates =
                this.carouselList?.instance?.carouselOuterList?.current?.getBoundingClientRect()
            }
            handled = false

            this.setState({
              carouselFocused: true,
              buttonFocus: false,
              focusedComponent: 'CarouselList',
            })
          }
        }
        if ('UP' === key) {
          if (this.heroCarousel) {
            this.heroCarousel?.setFocus()
            handled = true
            this.setState({
              carouselFocused: false,
              buttonFocus: false,
              focusedComponent: 'HeroCarousel',
            })
          }
        }
        if ('RIGHT' === key) {
          tts.addTextToRead(`Focused on ${this.button.props.label}.`)

          this.button?.setFocus()
          this.setState({
            carouselFocused: false,
            buttonFocus: true,
            focusedComponent: 'button',
          })
          handled = true
        }
        if ('ENTER' === key) {
          this.setState({
            carouselFocused: false,
            buttonFocus: false,
            descriptionModalVisible: true,
          })
          handled = true
        }
        if ('BACK' === key) {
          if (this.state.descriptionModalVisible === false) {
            handled = false
          } else {
            handled = true
          }
        }
      }

      if ('descriptionModal' === focusedComponent.componentType) {
        if ('DOWN' === key) {
          handled = true
        }
        if ('ENTER' === key) {
          handled = true
        }
        if ('BACK' === key) {
          this.setState({
            carouselFocused: false,
            buttonFocus: false,
            descriptionModalVisible: false,
          })
          this.descriptionText?.setFocus()
          handled = true
        }
      }

      // Hero Carousel has Focus
      if ('heroCarouselItem' === focusedComponent.componentType) {
        if ('DOWN' === key) {
          tts.addTextToRead(
            `${truncate.apply(this.state.pageDetails.description_long, [
              170,
              true,
            ])}`
          )
          handled = true

          this.setState({
            carouselFocused: false,
            buttonFocus: false,
            focusedComponent: 'descriptionText',
          })
          this.descriptionText?.setFocus()
        }
      }

      // Carousel Item has Focus
      if ('carouselItem' === focusedComponent.componentType) {
        if ('UP' === key) {
          tts.addTextToRead(
            `${truncate.apply(this.state.pageDetails.description_long, [
              170,
              true,
            ])}`
          )
          handled = true

          this.setState({
            carouselFocused: false,
            buttonFocus: false,
            focusedComponent: 'descriptionText',
          })
          this.continueWatchingRef.current.setFocus()
        }
      }

      if ('BACK' === key && handled === false) {
        // Take user back to screen before the error occurred or to the root in the case of deeplinking.
        if (deeplinked()) {
          this.props.router.navigate('/home')

          store.dispatch({
            type: 'DEEPLINK_URL',
            payload: {
              deeplinkedTo: false,
            },
          })
        } else {
          this.props.router.navigate(-1)
        }
        handled = true
      }
    }

    return handled
  }

  setHeroCarouselRef(heroCarousel) {
    if (null !== heroCarousel) {
      this.heroCarousel = heroCarousel
      if ('HeroCarousel' === this.state.focusedComponent) {
        // fall back for instances where there are no heroCarousel items
        if ('undefined' !== typeof this.heroCarousel) {
          this.heroCarousel?.setFocus()
        } else {
          this.button?.setFocus()
        }
      }
    }
  }

  setContinueWatchingRef = (component) => {
    if (null !== component) {
      this.continueWatchingRef.current = component
      this.continueWatchingRef.current.setFocus()
    }
  }

  errorModal({ title }) {
    this.setState({
      errorVisible: true,
      errorModalTitle: title,
      errorButtons: [
        {
          label: 'Go Back',
          name: 'goBackButton',
          onClick: () => {
            this.toggleErrorModal()
          },
        },
      ],
    })
  }

  render() {
    const {
      carouselFocused,
      errorButtons,
      errorVisible,
      errorModalMessage,
      errorModalTitle,
      spinnerVisible,
      hasLogo,
      hasImages,
      hasHero,
    } = this.state

    const { pageDetails, collections } = this.props.showDetail

    return (
      <>
        <Spinner visible={spinnerVisible} screen={true} />
        {errorVisible && (
          <ErrorModal
            title={errorModalTitle}
            description={errorModalMessage}
            buttons={errorButtons}
            componentType="errorModal"
            visible={errorVisible}
            toggle={this.toggleErrorModalBound}
            hideStationLogo={true}
            ref={(component) => {
              this.setErrorModalRef(component, 'errorModal')
            }}
          />
        )}

        <div
          className={`show-detail-screen-container ${hasHero ? 'hasHero' : ''}`}
          style={{
            transitionProperty: spinnerVisible ? 'none' : 'transform',
            transitionDuration: !PLATFORM_HAS_ANIMATIONS ? '0s' : '400ms',
            transform: carouselFocused
              ? `translate(0px, -${this.state.headerHeight}px)`
              : '',
          }}
        >
          <div className="header" ref={this.headerHeightRef}>
            {spinnerVisible ? null : (
              <>
                <ContinueWatching
                  ref={this.setContinueWatchingRef}
                  parent={this}
                  toggleError={this.errorModal}
                />
                {'undefined' !== typeof pageDetails && (
                  <div
                    className={`details ${
                      hasLogo ? 'hasLogo' : hasImages ? 'hasImages' : ''
                    }`}
                  ></div>
                )}
              </>
            )}
          </div>
          {spinnerVisible ? null : (
            <>
              {'undefined' !== typeof collections &&
                'undefined' !== typeof pageDetails && (
                  <CarouselList
                    collections={collections}
                    hasSeasons={collections.find((collection) => {
                      return collection.slug === 'show-seasons'
                    })}
                    spinnerVisible={spinnerVisible}
                    emptyMessage={true}
                    slug={this.props.router.params.slug}
                    parentTitle={pageDetails.title}
                    parent={this}
                    hideTitle={true}
                    hideMetaData={false}
                    funderMessage={pageDetails['funder_message']}
                    ref={(ref) => {
                      if (null !== ref) {
                        this.carouselList = ref
                      }
                    }}
                  />
                )}
            </>
          )}
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    stationId: state.station.station_id,
    ui: state.ui,
    UID: state.device.UID,
    callSign: state.station['call_sign'],
    deviceModel: state.device.deviceModel,
    favorites: state.personalization.favorites,
    favoritesFullyLoaded: state.personalization.favoritesFullyLoaded,
    userId: state.user.pid,
    showDetail: state.showDetail,
  }
}

ShowDetailsScreen.propTypes = {
  ui: PropTypes.shape({
    focusedComponent: PropTypes.string,
  }),
  UID: PropTypes.string,
  callSign: PropTypes.string,
  dispatch: PropTypes.func,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    navigate: PropTypes.func,
    params: PropTypes.shape({
      slug: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
  favorites: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  favoritesFullyLoaded: PropTypes.bool,
  deviceModel: PropTypes.string,
  stationId: PropTypes.string,
  userId: PropTypes.string,
  showDetail: PropTypes.shape({
    collections: PropTypes.array,
    continueWatchingData: PropTypes.object,
    pageDetails: PropTypes.object,
  }),
}

export default connect(
  mapStateToProps,
  null,
  null
)(withRouter(focusable(ShowDetailsScreen)))
